import {
	ChangeDetectionStrategy,
	Component,
	inject,
	Input,
	OnChanges,
	signal,
	SimpleChanges,
	WritableSignal,
} from '@angular/core'
import { WidgetInterface } from '@modules/widgets-module/interfaces/widget.interface'
import { AssetClassEnum } from '@modules/positions-module/enums/asset-class.enum'
import { TranslatePipe } from '@ngx-translate/core'
import { WidgetsService } from '@modules/widgets-module/services/widgets.service'
import { UseLocales } from '@modules/lang-module/decorators/use-locales'
import ru from './core/locale/ru.json'
import en from './core/locale/en.json'
import { ButtonComponent } from '@shared/components/ui-kit/button/button.component'

@UseLocales({ ru, en })
@Component({
	selector: 'app-asset-type',
	templateUrl: './asset-type.component.html',
	styleUrl: './asset-type.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TranslatePipe, ButtonComponent],
})
export class AssetTypesComponent implements OnChanges {
	protected readonly assetClassEnum: typeof AssetClassEnum = AssetClassEnum

	@Input() widget: WidgetInterface | null = null

	private readonly _widgetsService: WidgetsService = inject<WidgetsService>(WidgetsService)

	protected activeAssetClass: WritableSignal<AssetClassEnum> = signal(this.assetClassEnum.US_EQUITY)

	private _updateWidget(): void {
		if (!this.widget) return

		this._widgetsService.updateWidget({
			...this.widget,
			assetClass: this.activeAssetClass(),
		})
	}

	protected changeAssetClass(assetClass: AssetClassEnum): void {
		this.activeAssetClass.set(assetClass)
		this._updateWidget()
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['widget']) {
			if (!this.widget) return

			this.activeAssetClass.set(this.widget.assetClass ?? this.assetClassEnum.US_EQUITY)
		}
	}
}
